export default "__VITE_ASSET__07322f83__"